import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('impostazioniCpa');
export const actions = helper.createActions('impostazioniCpa', actionTypes);